import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavigationUtil } from 'utils/NavigationUtil';
import { RouteNames } from 'router';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { TestimonialActions } from 'modules/testimonials/action';
import { TestimonialSelector } from 'modules/testimonials/selector';
import { PageLoader } from 'components/molecules/pageLoader';
import CareersBanner from 'components/organisms/careersBanner';
import { ContactUsSection } from 'components/templates/contactUsSection';
import FooterSection from 'components/templates/footer';
import PageTemplate from 'components/templates/pageTemplate';
import Testimonial from 'components/templates/testimonial/careerTestimonial';
import { useViewport } from 'components/templates/viewportProvider';
import WorkingAtTESection from 'components/templates/workingAtTE';
import { isEmpty } from 'lodash';
import CultureLeadershipSection from 'components/templates/cultureLeadershipSection';
import { CareerActions } from 'modules/careers/actions';
import { CareerSelector } from 'modules/careers/selector';
import JobPostsSection from 'components/templates/jobs';
import { CmsDetailsActions } from 'modules/cmsDetails/actions';
import { CmsDetailsSelector } from 'modules/cmsDetails/selector';
import RenderSEO from 'components/atoms/renderSEO';
import { FooterSelector } from 'modules/footerLink/selector';
import { FooterActions } from 'modules/footerLink/actions';

const Careers = props => {
  const {
    isLoading,
    getContactDetails,
    contact,
    getVerticals,
    verticals,
    verticalId,
    getSiteSettings,
    siteSettings,
    careersBanner,
    footerLink,
    getFooterLinkData,
    getBannerData,
    getPageData,
    getTestimonialData,
    testimonialData,
    workingAtTESectionData,
    ourDifferenceData,
    getJobPosts,
    jobPosts,
    cmsDetailsData,
    getCmsDetailsData,
  } = props;

  const metaTagSEO = {
    metaTitle: 'Careers | Total Environment Homes',
    metaDescription:
      'Know about career openings in Total Environment, fill the given form or contact us at +91 80 4245 3000',
    metaKeywords: '',
  };

  const { isMobile } = useViewport();
  const type = 'Career';
  let [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');

  useEffect(() => {
    getContactDetails();
    getVerticals();
    getSiteSettings();
    getBannerData();
    getPageData();
    getTestimonialData(verticalId, type);
    getJobPosts();
    getFooterLinkData();
    getCmsDetailsData();
  }, []);

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (
    !careersBanner ||
    !workingAtTESectionData ||
    !siteSettings ||
    !contact ||
    !testimonialData ||
    !verticals ||
    !ourDifferenceData ||
    !jobPosts ||
    !getCmsDetailsData ||
    !footerLink
  ) {
    return null;
  }

  if (careersBanner.metaTitle) metaTagSEO.metaTitle = careersBanner.metaTitle;
  if (careersBanner.metaDescription)
    metaTagSEO.metaDescription = careersBanner.metaDescription;
  if (careersBanner.metaKeywords)
    metaTagSEO.metaKeywords = careersBanner.metaKeywords;

  const componentList = [
    ...(!isEmpty(careersBanner)
      ? [
          {
            component: CareersBanner,
            data: careersBanner,
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(workingAtTESectionData)
      ? [
          {
            component: WorkingAtTESection,
            data: { workingAtTESectionData },
            theme: 'light-theme',
            sectionId: 'working-at-total-env',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: 'Working at Total Environment',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(jobPosts)
      ? [
          {
            component: JobPostsSection,
            data: jobPosts,
            theme: 'dark-theme',
            sectionId: 'jobs',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: 'Open Positions',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(testimonialData)
      ? [
          {
            component: Testimonial,
            sectionId: 'testimonials',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: 'Testimonials',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: { testimonialData, type: 'testimonial' },
          },
        ]
      : []),
    ...(!isEmpty(ourDifferenceData)
      ? [
          {
            component: CultureLeadershipSection,
            data: {
              ourDifferenceData,
              cmsDetailsData,
            },
            sectionId: 'culture-and-leadership',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: 'Culture & Leadership Principles',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    {
      component: ContactUsSection,
      data: {
        contact,
        verticals,
        verticalId,
        type: 'no-padding',
        showVerticalDropdown: false,
        projectName: 'Career',
      },
      location: props,
      sectionId: 'contact',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Careers',
          breadcrumbLink: RouteNames.careers,
        },
        {
          breadcrumbName: 'Contacts',
          breadcrumbLink: '#',
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Careers',
          breadcrumbLink: RouteNames.careers,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <>
      <RenderSEO metaTags={metaTagSEO} />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
      />
    </>
  );
};

const mapStateToProps = (state, props) => {
  const verticalKey = NavigationUtil.getVerticalKeyForLocation(props.location);

  return {
    isLoading:
      CareerSelector.isCareerLandingPageLoading(state) ||
      HomeSelector.isLoading(state) ||
      FooterSelector.isLoading(state) ||
      TestimonialSelector.getTestimonialLoading(state) ||
      CmsPagesSelector.isCmsPageLoading(state) ||
      CmsDetailsSelector.getCmsDetailsDataLoading(state),
    contact: HomeSelector.getContactForMenuItems(state, 'Career'),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    verticals: HomeSelector.getVerticals(state),
    footerLink: FooterSelector.getFooterData(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    careersBanner: HomeSelector.getBanners(state, false, '', 'Career'),
    testimonialData: TestimonialSelector.getTestimonialData(state),
    workingAtTESectionData: CmsPagesSelector.getCmsPages(
      state,
      'Working at Total Environment',
      true
    ),
    ourDifferenceData: CmsPagesSelector.getOurDifferenceSection(
      state,
      'culture-leadership',
      'Culture & Leadership Principles'
    ),
    jobPosts: CareerSelector.getJobPosts(state),
    cmsDetailsData: CmsDetailsSelector.getCmsDetailsData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const {
    getVerticals,
    getSiteSettings,
    getBannerData,
    getContactDetails,
  } = HomeActions;
  const { getPageData } = CmsPagesActions;
  const { getTestimonialData } = TestimonialActions;
  const { getJobPosts } = CareerActions;
  const { getFooterLinkData } = FooterActions;
  const { getCmsDetailsData } = CmsDetailsActions;
  return bindActionCreators(
    {
      getBannerData,
      getContactDetails,
      getSiteSettings,
      getVerticals,
      getPageData,
      getTestimonialData,
      getJobPosts,
      getFooterLinkData,
      getCmsDetailsData,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Careers);
